<template>
  <div class="home-box">
    <home-carousel :carousel="homeData?.banner" class="top-carousel" />
    <home-card name="新闻中心" class="news-card">
      <div v-if="homeData" class="news-home-card">
        <div class="news-left-card">
          <div class="first-news">
            <div class="news-title text-ellipsis">
              <span @click="handleClick(homeData.firstNews)">{{ homeData.firstNews.newsTitle }}</span>
            </div>
            <!-- 简介 -->
            <div class="news-intro">{{ homeData.firstNews.newsSubcontent.substring(0, 50) }}...<a @click="handleClick">&nbsp;[详情]&nbsp;</a></div>
          </div>
          <InfoList :list="homeData.news" />
        </div>
        <div class="news-right-carsousel">
          <home-carousel :carousel="homeData?.picture.slice(0, 6)" />
        </div>
      </div>
    </home-card>
    <div class="middle-cards">
      <div class="middle-left">
        <home-card name="运营管理"><InfoList v-if="homeData" :list="homeData.venue" /></home-card>
        <home-card name="安全生产"><InfoList v-if="homeData" :list="homeData.safety" /></home-card>
      </div>
      <div class="middle-middle">
        <home-card name="党风廉政"><InfoList v-if="homeData" :list="homeData.integrity" /></home-card>
        <home-card name="企业文化">
          <p class="culture-logo-info">Logo释义：标志由“合肥文旅”四个字的首个拼音字母“HFWL”作为主元素设计而成，把天之四灵之一的朱雀注入其中，朱雀代表着长生吉祥之意，图形整体来看又是“文”字的首个拼音字母“W”，寓意企业以文化为核心的经营思路。整个标志清晰简洁，视...</p>
          <InfoList v-if="homeData" :list="homeData.culture.slice(0, 2)" /></home-card>
      </div>
      <div class="middle-right">
        <home-card name="通知公告" class="notice-card"><InfoList v-if="homeData" :list="homeData.notice" /></home-card>
        <home-card name="媒体聚焦" class="media-focus-card"><InfoList v-if="homeData" :list="homeData.focus.slice(0, 6)" :hiddenDate="true" /></home-card>
        <home-card name="视频展示" menuId="002005" class="video-card">
          <div class="video-box" @click="handleClick(homeData?.video[0])">
            <img width="220" height="120" :src="homeData?.video[0]?.newsImg" alt="" />
            <img width="60px" height="60px" class="video-play" src="../../assets/images/bf.png" alt="" />
          </div>
        </home-card>
      </div>
    </div>
    <home-card class="bottom-cards" name="项目风采">
      <div class="left-button"></div>
      <div class="style-imgs" v-if="homeData">
        <img-news-card :imgStyle="imgStyle" v-for="item in homeData.style" :key="item.id" :news="item" />
      </div>
      <div class="right-button"></div>
    </home-card>
  </div>
</template>
<script>
import HomeCard from './comp/HomeCard.vue';
import HomeCarousel from './comp/HomeCarousel.vue';
import InfoList from './comp/InfoList.vue';
import ImgNewsCard from '@/components/ImgNewsCard.vue'
import { homePageController } from '@/api/apis.js';

export default {
  components: {
    HomeCarousel,
    HomeCard,
    InfoList,
    ImgNewsCard
  },
  data () {
    return {
      imgStyle: {
        width: "200px",
        height: "140px",
      },
      homeData: null
    }
  },
  created() {
    this.getAallHomeData()
  },
  methods: {
    getAallHomeData() {
      homePageController().then(res => {
        this.homeData = res.data || {}
        // this.homeData.banner = this.homeData?.banner.map((item) => {
        //   return {
        //     ...item,
        //     url: `${location.origin}/ctep-file/${item.image}`
        //   }
        // })
        this.homeData.firstNews = this.homeData?.news[0] || {}
        this.homeData.news = this.homeData?.news.slice(1)
      })
    },
    handleClick(info) {
      if(!info.id) return
      this.$router.push({
        path: `/index/info/${info.id}`,
        query: {
          linkMenuId: info?.newsMenuId || ""
        }
      })
    } 
  }
};
</script>

<style lang="scss" scoped>
.home-box ::v-deep {
  margin-top: 5px;
  display: flex;
  gap: 20px;
  flex-direction: column;
  .top-carousel {
    border: 1px solid #dddddd;
  }
  .news-card {
    .news-home-card {
      margin-bottom: 15px;
      display: flex;
      gap: 40px;
      justify-content: space-between;
      .news-left-card {
        width: 40%;
        .first-news {
          border: 1px solid #ddd;
          padding: 0 15px;
          margin-bottom: 10px;
          .news-title {
            cursor: pointer;
            font-size: 18px;
            line-height: 28px;
            color: #0268b3;
            &:hover {
              color: #fcc200;
            }
          }
          .news-intro {
            font-size: 12px;
            line-height: 20px;
            a {
              cursor: pointer;
              color: #fcc200;
              &:hover {
                text-decoration: underline;
              }
            }
          }
        }
        .info-list-box {
          li {
            margin-top: 5px;
            &:first-child {
              margin-top: 0px;
            }
          }
        }
      }
      .news-right-carsousel {
        padding: 0;
        flex: 1;
      }
    }
  }
  .middle-cards {
    display: flex;
    gap: 18px;
    .middle-left, .middle-middle {
      width: calc(37.5% - 18px);
      display: flex;
      gap: 20px;
      flex-direction: column;
      .home-card-box {
        flex: 1
      }
    }
    .middle-right {
      width: calc(25%);
      display: flex;
      flex-direction: column;
      gap: 10px;
      .notice-card {
        overflow: hidden;
        height: 160px;
        .home-card-container {
          overflow: hidden;
          .info-list-box {
            animation: slideIn 5s linear infinite;
            &:hover {
              animation-play-state: paused;
            }
          }
        }
      }
      .media-focus-card {
        flex: 1;
        .info-list-box {
          > li {
            height: 25px;
            line-height: 25px;
            margin: 0;
          }
        }
      }
      .video-card {
        height: 190px;
        .video-box {
          width: 220px;
          height: 120px;
          position: relative;
          cursor: pointer;
          .video-play {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }
    .middle-middle {
      .culture-logo-info {
        height: 140px;
        margin: 10px 10px 0 10px;
        display: block;
        overflow: hidden;
        font-size: 12px;
        line-height: 23px;
        color: #777777;
      }
    }
  }
  .bottom-cards {
    .left-button, .right-button {
      height: 120px;
      width: 20px;
      overflow: hidden;
      display: inline;
      margin: 25px 0 0 0;
      cursor: pointer;
    }
    .left-button {
      float: left;
      background: url("../../assets/images/button.gif") no-repeat left -20px;
    }
    .right-button {
      float: right;
      background: url("../../assets/images/button.gif") no-repeat -20px -20px;
    }
    .style-imgs {
      float: left;
      overflow: hidden;
      white-space: nowrap;
      width: 910px;
      margin: 0 10px 10px 10px;
      .img-news-card {
        overflow: hidden;
        display: inline-block;
        width: 228px;
        height: 265px;
        padding: 0 14px;
        background: none;
        .img-box {
          width: 200px;
          height: 140px;
        }
      }
    }
  }
}

@keyframes slideIn {
  from {
    transform: translateY(110px);
  }
  to {
    transform: translateY(-100%);
  }
}
</style>